var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex content-center"},[_c('c-pagination',{attrs:{"size":"sm","active-page":this.currentPage,"pages":_vm.numPages},on:{"update:activePage":_vm.goToPage}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }